import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectUserPasswordReset = createSelector([(state: AppState) => state.shared.resetUserPassword], state => state);
